import './style.css'
import { applyRecording } from './engine/constants'
import { loadRecordings } from './engine/recordings'
import { mount } from './ui/app'

async function boot(): Promise<void> {
  const recordings = await loadRecordings()

  // ?r=<id> selects a recording; anything unknown falls back to the built-in
  // mosaic rather than erroring, so stale links keep working.
  const wanted = new URLSearchParams(window.location.search).get('r')
  const active = recordings.find((r) => r.id === wanted) ?? recordings[0]!

  // Every timing fact in the engine derives from this. It runs exactly once
  // per page load — switching recordings reloads the page.
  applyRecording(active)

  const player = mount(recordings, active)

  // Release the audio context and any decoded frames if the page is torn down.
  window.addEventListener('pagehide', () => {
    void player.dispose()
  })
}

void boot()
